import { faArrowTrendUp } from '@fortawesome/pro-regular-svg-icons/faArrowTrendUp';
import { faBadgeCheck } from '@fortawesome/pro-regular-svg-icons/faBadgeCheck';
import { faCalendarDay } from '@fortawesome/pro-regular-svg-icons/faCalendarDay';
import { faComment } from '@fortawesome/pro-regular-svg-icons/faComment';
import { faIcons } from '@fortawesome/pro-regular-svg-icons/faIcons';
import { faLanguage } from '@fortawesome/pro-regular-svg-icons/faLanguage';
import { faListCheck } from '@fortawesome/pro-regular-svg-icons/faListCheck';
import { faNoteSticky } from '@fortawesome/pro-regular-svg-icons/faNoteSticky';
import { faPaperPlane } from '@fortawesome/pro-regular-svg-icons/faPaperPlane';
import { faSquareCheck } from '@fortawesome/pro-regular-svg-icons/faSquareCheck';
import { faTag } from '@fortawesome/pro-regular-svg-icons/faTag';
import { ReactNode } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faMapPin } from '@fortawesome/pro-light-svg-icons/faMapPin';

export type WidgetVariant = keyof typeof WIDGET_VARIANT_PROPERTIES;

export const WIDGET_VARIANT_PROPERTIES = {
  translation: {
    className: 'tw-text-blue-alt-dark tw-bg-blue-alt-light',
    icon: faLanguage,
    emptyMessage: 'widgets.emptyMessage.translation',
    title: 'widgets.title.translation',
  },
  postCompletion: {
    className: 'tw-text-burgundy-dark tw-bg-burgundy-light',
    icon: faBadgeCheck,
    emptyMessage: 'widgets.emptyMessage.postCompletion',
    title: 'widgets.title.postCompletion',
  },
  labels: {
    className: 'tw-text-purple-100 tw-bg-purple-10',
    icon: faTag,
    emptyMessage: 'widgets.emptyMessage.labels',
    title: 'widgets.title.labels',
  },
  notes: {
    className: 'tw-text-orange-100 tw-bg-orange-10',
    icon: faNoteSticky,
    emptyMessage: 'widgets.emptyMessage.notes',
    title: 'widgets.title.notes',
  },
  boostBudget: {
    className: 'tw-text-danger-100 tw-bg-danger-10',
    icon: faArrowTrendUp,
    emptyMessage: 'widgets.emptyMessage.boostBudget',
    title: 'widgets.title.boostBudget',
  },
  postRequirements: {
    className: 'tw-text-turquoise-100 tw-bg-turquoise-10',
    icon: faListCheck,
    emptyMessage: 'widgets.emptyMessage.postRequirements',
    title: 'widgets.title.postRequirements',
  },
  tasks: {
    className: 'tw-text-success-120 tw-bg-success-10',
    icon: faSquareCheck,
    emptyMessage: 'widgets.emptyMessage.tasks',
    title: 'widgets.title.tasks',
  },
  communication: {
    className: 'tw-text-blueberry-dark tw-bg-blueberry-light',
    icon: faComment,
    emptyMessage: 'widgets.emptyMessage.communication',
    title: 'widgets.title.communication',
  },
  postContent: {
    className: 'tw-text-primary-100 tw-bg-primary-10',
    icon: faIcons,
    emptyMessage: 'widgets.emptyMessage.postContent',
    title: 'widgets.title.postContent',
  },
  localPosts: {
    className: 'tw-text-primary-100 tw-bg-primary-10',
    icon: faMapPin,
    emptyMessage: 'widgets.emptyMessage.localPosts',
    title: 'widgets.title.localPosts',
  },
  localPost: {
    className: 'tw-text-primary-100 tw-bg-primary-10',
    icon: faMapPin,
    emptyMessage: 'widgets.emptyMessage.localPost',
    title: 'widgets.title.localPost',
  },
  publishingMethod: {
    className: 'tw-text-grayscale-100 tw-bg-grayscale-10',
    icon: faPaperPlane,
    emptyMessage: 'widgets.emptyMessage.publishingMethod',
    title: 'widgets.title.publishingMethod',
  },
  postPlanning: {
    className: 'tw-text-teal-120 tw-bg-teal-10',
    icon: faCalendarDay,
    emptyMessage: 'widgets.emptyMessage.postPlanning',
    title: 'widgets.title.postPlanning',
  },
} satisfies Record<
  string,
  {
    className: string;
    icon: IconDefinition;
    emptyMessage: ReactNode;
    title: string;
  }
>;
